import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import cx from 'classnames';

import { trans } from '../../../../common/utils';
import { LLInput, llNotifier, LLPreloader } from '../../../../components';
import { DeleteFavoriteItemModal } from './delete-fav-tournament-modal';
import { urls } from '../../../../configs';
import MyFavoriteSportSelect from './sport-select';

const MyFavoriteTeam = ({ team, favorites, modal, isFavorite, setView, setTab, teamSearchValue }) => {
    return (
        <p className="my-favorite__list-item">
            <span className="my-favorite__list-item-fav-icon-wrp">
                <i
                    className={`my-favorite__list-item-fav-icon doruk-star-${isFavorite ? 'fill' : 'line'}`}
                    onClick={() => {
                        isFavorite
                            ? modal.setModal({
                                  active: true,
                                  maskBackground: true,
                                  showHeader: true,
                                  title: trans('Favorite teams'),
                                  showCloseButton: true,
                                  currentKey: 'custom-content',
                                  customClasses: 'delete-favorite-modal',
                                  customContent: (
                                      <DeleteFavoriteItemModal
                                          deleteItem={(e) => {
                                              e.preventDefault();
                                              favorites.setFavoriteTeam({
                                                  competitorId: team.id,
                                                  sportId: team.sportId,
                                                  isFavorite: true,
                                              });
                                              modal.close();
                                          }}
                                          type="team"
                                      />
                                  ),
                              })
                            : favorites.setFavoriteTeam({
                                  competitorId: team.id,
                                  sportId: team.sportId,
                                  isFavorite: false,
                              });
                    }}
                ></i>
            </span>
            <span
                className={cx('my-favorite__list-item-content', isFavorite && 'clickable')}
                onClick={() => {
                    if (isFavorite) {
                        favorites.initializeInstruction({
                            type: 'teams',
                        });
                        setTab('teams');
                        favorites.setCurrentId(team.id, 'teams');
                        setView('matches');
                    }
                }}
            >
                <span className="my-favorite__list-item-sport-icon">
                    <i className={`sport_icon_font-${team.sportId}`}></i>
                </span>
                <span
                    className="my-favorite__list-item-name"
                    dangerouslySetInnerHTML={{
                        __html: teamSearchValue ? team.name?.replace(new RegExp(teamSearchValue, 'gi'), "<span class='my-favorite__list-item-name--highlited'>$&</span>") : team.name,
                    }}
                />
                <span className="my-favorite__list-item-logo-wrp">
                    {team.teamHasLogo ? <img className="my-favorite__list-item-team-logo" src={urls.prematchCompetitorImg + team.id + '.png'} alt={team.name} /> : null}
                </span>
            </span>
        </p>
    );
};

const MyFavoriteTeams = ({ store, view, setView, tab, setTab }) => {
    const [searchValSport, setSearchValSport] = useState(null),
        [searchVal, setSearchVal] = useState('');

    const searchTeams = store.betting.favorites.searchTeams,
        error = store.betting.bettingErrors.favoriteTeams,
        favTeams = store.betting.favorites.teams,
        storeSearchValue = store.betting.favorites.teamsSearchValue,
        viewSize = store.site.status.viewSize;

    useEffect(() => {
        setView('default');
    }, []);

    const search = () => {
        if (searchVal?.length && searchVal?.length < 3) {
            llNotifier({
                message: 'Minimum 3 characters required',
                type: 'warning',
                options: {},
            });
            return null;
        }
        const params = { searchVal };
        if (searchValSport.id) {
            params.sportId = searchValSport.id;
        }
        store.betting.favorites.getSearchTeams(params);
        store.betting.favorites.setCurrentId(null, 'teams');
        setView('default');
    };

    return (
        <div className="my-favorite__teams">
            <div className="my-favorite__column-top">
                <MyFavoriteSportSelect setSearchValSport={setSearchValSport} searchValSport={searchValSport} />
                <LLInput
                    customClasses="my-favorite__teams-input"
                    placeholder={trans('Search for teams')}
                    mode="text"
                    id="my-favorite-team__search"
                    name="my-favorite-team__search"
                    value={searchVal}
                    onEnterKey={search}
                    onValueChanged={(e) => setSearchVal(e.value)}
                    stylingMode="outlined"
                    adormentAfter={
                        <div className={`my-favorite__teams-input-icons${storeSearchValue ? '--clear' : '--search'}`}>
                            <span className="my-favorite__teams-input-icon dx-icon-search icon" onClick={search} />
                            <span
                                className="my-favorite__teams-input-icon dx-icon-remove icon"
                                onClick={() => {
                                    setSearchVal('');
                                    store.betting.favorites.clearSearchTeams();
                                }}
                            />
                        </div>
                    }
                ></LLInput>
            </div>
            <div className={cx('my-favorite__column-header', tab === 'teams' && view === 'matches' && 'my-favorite__column-header--active')}>
                <p className="my-favorite__column-header-text">
                    {viewSize === 'mobile' ? <i className="my-favorite__column-header-icon doruk-tshirt"></i> : null}
                    <span>{trans('Teams')}</span>
                    {viewSize !== 'mobile' ? <span>({favTeams?.length ?? 0}/50)</span> : null}
                </p>
                <p
                    className="my-favorite__column-header-show-btn"
                    onClick={() => {
                        if (view === 'default') {
                            store.betting.favorites.initializeInstruction({
                                type: 'teams',
                            });
                            setTab('teams');
                            setView('matches');
                        }
                        if (view === 'matches') {
                            store.betting.favorites.setCurrentId(null, 'teams');
                            setView('default');
                        }
                    }}
                >
                    {trans(view === 'default' ? 'Show matches' : tab === 'teams' ? 'Clear matches' : '')}
                </p>
            </div>
            {view !== 'matches' ? (
                <div className="my-favorite__column-content-wrp">
                    {store.betting.favorites.teamsLoading && (
                        <div className="my-favorite__column-content-laoding">
                            <LLPreloader height={50} width={50} />
                        </div>
                    )}
                    <div className="my-favorite__column-content">
                        {storeSearchValue ? (
                            searchTeams?.length ? (
                                searchTeams.map((team) => {
                                    return (
                                        <MyFavoriteTeam
                                            team={team}
                                            favorites={store.betting.favorites}
                                            isFavorite={store.betting.favorites.isTeamFavorite({
                                                competitorId: team.id,
                                            })}
                                            setView={setView}
                                            setTab={setTab}
                                            teamSearchValue={storeSearchValue}
                                            modal={store.modal}
                                            key={team.id}
                                        />
                                    );
                                })
                            ) : (
                                <p className="my-favorite__no-content-text">{trans('NO_SEARCH_TEAMS_TEXT')}</p>
                            )
                        ) : !error && favTeams?.length ? (
                            favTeams.map((team) => (
                                <MyFavoriteTeam
                                    team={team}
                                    favorites={store.betting.favorites}
                                    isFavorite={store.betting.favorites.isTeamFavorite({
                                        competitorId: team.id,
                                    })}
                                    setView={setView}
                                    setTab={setTab}
                                    teamSearchValue={storeSearchValue}
                                    modal={store.modal}
                                    key={team.id}
                                />
                            ))
                        ) : (
                            <div className="my-favorite__no-content">
                                <i className="my-favorite__no-content-icon doruk-tshirt"></i>
                                <p className="my-favorite__no-content-text">{trans(error || 'NO_FAV_TEAMS_TEXT')}</p>
                            </div>
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default inject('store')(observer(MyFavoriteTeams));
